export { default } from './ResumeApplicationPageView';
export * from './ResumeApplicationPageView';
